module.exports = __webpack_public_path__ + "img/login_logo.e9e7fbd4.png";